/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AvailabilityInputs */

const en_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability`)
};

const es_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad`)
};

const fr_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité`)
};

const de_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit`)
};

const ja_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在庫状況`)
};

const zh_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`库存/可用性`)
};

const ar_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوفر`)
};

const id_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketersediaan`)
};

const it_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilità`)
};

const ru_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наличие`)
};

const pt_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidade`)
};

const ko_availability = /** @type {(inputs: AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재고/이용 가능 여부`)
};

/**
* | output |
* | --- |
* | "Availability" |
*
* @param {AvailabilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const availability = /** @type {((inputs?: AvailabilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AvailabilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_availability(inputs)
	if (locale === "es") return es_availability(inputs)
	if (locale === "fr") return fr_availability(inputs)
	if (locale === "de") return de_availability(inputs)
	if (locale === "ja") return ja_availability(inputs)
	if (locale === "zh") return zh_availability(inputs)
	if (locale === "ar") return ar_availability(inputs)
	if (locale === "id") return id_availability(inputs)
	if (locale === "it") return it_availability(inputs)
	if (locale === "ru") return ru_availability(inputs)
	if (locale === "pt") return pt_availability(inputs)
	return ko_availability(inputs)
});